import { useEffect } from "react";
import CSDTable from "@cloudscape-design/components-themed/table";
import { Box, Icon, SpaceBetween } from "@cloudscape-design/components-themed";
import {
  COMMON_LABELS,
  ApprovalStatusPattern,
  getStatus,
} from "../default-constants";
import { LABELS } from "./constants";
import { IndustryConversionReference } from "../../features/api-interfaces";
import { useGetIndustryConversionQuery } from "../../features/api";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../app/hook";
import type { RootState } from "../../app/store";

const columnDefinitions = [
  {
    id: "ruleNo",
    header: LABELS.RULE_NO,
    cell: (e: any) => (
      <Link to={"/industry-conversion/registry/" + e.conversionRuleNo}>
        {e.ruleNo}
      </Link>
    ),
  },
  {
    id: "approvalStatus",
    header: LABELS.APPROVAL_STATUS,
    cell: (e: any) =>
      e.approvalStatusName ===
      ApprovalStatusPattern.awaitingApproval.statusName ? (
        <SpaceBetween direction="horizontal" size="xxxs">
          <Icon name="flag" variant="error" />
          {e.approvalStatusName}
        </SpaceBetween>
      ) : (
        e.approvalStatusName
      ),
  },
  {
    id: "conversionFromIndustryName",
    header: LABELS.ORIGINALLY_NAME,
    cell: (e: any) => e.conversionFromIndustryName,
  },
  {
    id: "conversionAfterIndustryCode",
    header: LABELS.AFTER_CONVERSION_CODE,
    cell: (e: any) => e.conversionAfterIndustryCode,
  },
  {
    id: "conversionAfterIndustryName",
    header: LABELS.AFTER_CONVERSION_NAME,
    cell: (e: any) => e.conversionAfterIndustryName,
  },
  {
    id: "applicationStartDate",
    header: LABELS.ADAPTATION_START_DATE,
    cell: (e: any) => e.applicationStartDate,
  },
];

/*
業態変換一覧
 */
const Table = () => {
  const searchCondition = useAppSelector(
    (state: RootState) => state.industryConversionSearchCondition
  );

  const { data, isFetching, refetch } =
    useGetIndustryConversionQuery(searchCondition);

  const updateData = data?.map((status) => ({
    ...status,
    approvalStatusName: getStatus(status.approvalStatus),
  })) as IndustryConversionReference[];

  useEffect(() => {
    refetch();
  }, [refetch]);

  if (!data) return null;

  return (
    <CSDTable
      columnDefinitions={columnDefinitions}
      loading={isFetching}
      loadingText={COMMON_LABELS.CSD.LOADING_TEXT}
      trackBy="ruleNo"
      items={updateData}
      resizableColumns
      stickyHeader
      header={
        <SpaceBetween size="xs">
          <SpaceBetween direction="horizontal" size="l"></SpaceBetween>
        </SpaceBetween>
      }
      empty={
        <Box textAlign="center" color="inherit">
          {COMMON_LABELS.CSD.NO_DATA}
        </Box>
      }
    />
  );
};

export default Table;
